<template>
    <MainContent v-if="categoria" :title="'Resumen de la categoría ' + categoria.name">
        <template v-slot:header>
            <h4 class="pt-1 pb-3">Datos de deportistas</h4>
            <div class="ml-auto">
                <a :href="url_descarga_informe" class="btn btn-primary mr-3" target="blank">Informe</a>
                <a :href="url_descarga_informe_pdf" class="btn btn-primary mr-3" target="blank">Descargar listado</a>  
            </div>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div class="d-md-flex" v-if="!loading">
                    <CardIcon
                        class="col-md-6"
                        :title="'NÚMERO DE DEPORTISTAS:'"
                        :data="resumen.total_deportistas"
                        :icon="'fas fa-list'"
                    />
                    <CardIcon
                        class="col-md-6"
                        :title="'EDAD MEDIA:'"
                        :data="resumen.media_edad + ' años'"
                        :icon="'fas fa-percent'"
                    />
                </div>
                <ListadoDeportistas/>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import CardIcon from '@/components/backend/components/CardIcon';
    import ListadoDeportistas from "./Deportistas"

    export default {
        data() {
            return {
                loading: false,
                resumen: null,
                categoria_id: this.$route.params.categoria_id,
                categoria: null
            }
        },
        methods: {
            getResumen() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    categoria_id: this.categoria_id,
                    filters: {}
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.resumen'), params).then(res => {
                    this.resumen = res.data.resumen;
                    this.categoria = res.data.categoria;
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            url_descarga_informe() {
                return this.config.API_BASE + '/listas-abonados/' + this.lista_id + '/bases/categorias/' + this.categoria_id + '/resumen/bases/informe?api_key=' + localStorage.getItem('token');
            },
            url_descarga_informe_pdf() {
                return this.config.API_BASE + '/listas-abonados/' + this.lista_id + '/bases/categorias/' + this.categoria_id + '/resumen/bases/informe/bases-pdf?api_key=' + localStorage.getItem('token');
            },
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        created() {
            this.getResumen();
        },
        components: { MainContent, ListadoDeportistas, ContentOrLoading, CardIcon }
    }
</script>